import React from 'react';
import Icon from '../../../components/AppIcon';

const HouseCuspsSection = ({ data, isVisible, onToggle }) => {
  if (!data || data?.length === 0) return null;

  return (
    <section id="house-cusps" className="scroll-mt-20">
      <div className="bg-card border border-border rounded-lg shadow-brand-md overflow-hidden">
        <button
          onClick={onToggle}
          className="w-full flex items-center justify-between px-4 md:px-6 py-4 hover:bg-muted transition-smooth"
          aria-expanded={isVisible}
        >
          <div className="flex items-center">
            <div className="w-10 h-10 bg-secondary/10 rounded-lg flex items-center justify-center mr-3">
              <Icon name="Home" size={20} color="var(--color-secondary)" />
            </div>
            <div className="text-left">
              <h2 className="text-lg md:text-xl font-heading font-semibold text-foreground">
                จุดเริ่มต้นบ้าน
              </h2>
              <p className="text-xs md:text-sm text-muted-foreground">House Cusps</p>
            </div>
          </div>
          <Icon 
            name={isVisible ? "ChevronUp" : "ChevronDown"} 
            size={24} 
            color="var(--color-muted-foreground)"
          />
        </button>

        {isVisible && (
          <div className="border-t border-border">
            {/* Desktop Table View */}
            <div className="hidden lg:block overflow-x-auto">
              <table className="w-full">
                <thead className="bg-muted">
                  <tr>
                    <th className="px-6 py-3 text-left text-sm font-caption font-medium text-foreground uppercase tracking-wide">
                      บ้าน
                      <span className="block text-xs text-muted-foreground normal-case">House</span>
                    </th>
                    <th className="px-6 py-3 text-left text-sm font-caption font-medium text-foreground uppercase tracking-wide">
                      องศาจุดเริ่มต้น
                      <span className="block text-xs text-muted-foreground normal-case">Cusp Degree</span>
                    </th>
                    <th className="px-6 py-3 text-left text-sm font-caption font-medium text-foreground uppercase tracking-wide">
                      ราศี
                      <span className="block text-xs text-muted-foreground normal-case">Zodiac Sign</span>
                    </th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-border">
                  {data?.map((house, index) => (
                    <tr key={index} className="hover:bg-muted/50 transition-smooth">
                      <td className="px-6 py-4 text-sm data-text font-medium text-foreground">
                        {house?.houseNumber}
                      </td>
                      <td className="px-6 py-4 text-sm data-text text-foreground">
                        {house?.cuspDegree}°
                      </td>
                      <td className="px-6 py-4 text-sm text-foreground">
                        {house?.zodiacTh}
                        <span className="block text-xs text-muted-foreground">{house?.zodiacEn}</span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {/* Mobile Card View */}
            <div className="lg:hidden divide-y divide-border">
              {data?.map((house, index) => (
                <div key={index} className="p-4 hover:bg-muted/50 transition-smooth">
                  <div className="flex items-center justify-between mb-3">
                    <div>
                      <h3 className="text-base font-medium text-foreground">บ้านที่ {house?.houseNumber}</h3>
                      <p className="text-sm text-muted-foreground">House {house?.houseNumber}</p>
                    </div>
                    <div className="text-right">
                      <p className="text-base data-text font-medium text-foreground">{house?.cuspDegree}°</p>
                    </div>
                  </div>
                  <div>
                    <p className="text-xs text-muted-foreground mb-1">ราศี (Zodiac Sign)</p>
                    <p className="text-sm text-foreground">{house?.zodiacTh}</p>
                    <p className="text-xs text-muted-foreground">{house?.zodiacEn}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default HouseCuspsSection;